module.exports = __webpack_public_path__ + "static/media/meeting_r2.b01d5587.png";